import React, { useRef, useState } from "react";
import fetchURLForm from "../../../functions/fetchURLForm";
import { fetchUrl } from "../../../functions/fetchUrl";

const EditService = ({ data, showEditingStoreBox }) => {
  const service = useRef("");
  const country = useRef("");

  const url = useRef("");
  const notification_url = useRef("");

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  // to set imageWidget state as an image

  const handleSave = async (event) => {
    event.preventDefault();
    // const body = new FormData();

    // body.append("service", service.current.value);
    // body.append("country", country.current.value);
    // body.append("url", url.current.value);
    // body.append("notification_url", notification_url.current.value);

    const bodySend = {
      service: service.current.value,
      country: country.current.value,
      url: url.current.value,
      notification_url: notification_url.current.value,
    };

    const response = await fetchUrl({
      apiName: `services/${data.id}`,
      method: "PUT",
      reqBody: bodySend
    });
    if (response.success) {
      setSuccess(true);
    } else {
      setError(true);
      console.log(response);
    }
  };
  const hideAlert = () => {
    setSuccess(false);
    setError(false);
  };
  return (
    <div
      id="addNoteModal"
      className="modal"
      style={{
        zIndex: "99999",
      }}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2>
            Edit Service <span className="text-warning">{data.name}</span>{" "}
          </h2>
        </div>
        <div>
          {success && (
            <div className="alert alert-success" role="alert">
              Edited Successfully...
            </div>
          )}
          {error && (
            <div className="alert alert-anger" role="alert">
              Edited Failed Try Again...
            </div>
          )}
        </div>
        <form
          className="w-100 p-5"
          encType="multipart/form-data"
          onSubmit={handleSave}
        >
          <div className="mt-2">
            <label htmlFor="service">Service Name</label>
            <input
              ref={service}
              type="text"
              id="service"
              placeholder="Name Of Store"
              className="form-control"
              required
              defaultValue={data.service}
              onChange={hideAlert}
            />
          </div>
          <div className="mt-2">
            <label htmlFor="country">Country</label>
            <input
              ref={country}
              type="text"
              id="country"
              placeholder="country"
              className="form-control"
              required
              defaultValue={data.country}
              onChange={hideAlert}
            />
          </div>
          <div className="mt-2">
            <label htmlFor="url">Landing URL</label>
            <input
              ref={url}
              type="text"
              id="url"
              placeholder="url"
              className="form-control"
              required
              defaultValue={data.url}
              onChange={hideAlert}
            />
          </div>
          <div className="mt-2">
            <label htmlFor="notification_url">Notification Link</label>
            <input
              ref={notification_url}
              type="text"
              id="notification_url"
              className="form-control"
              required
              defaultValue={data.notification_url}
              onChange={hideAlert}
            />
          </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">
              Update
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={showEditingStoreBox}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditService;
